module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-US":{"buttons":{"edit":"Edit","remove":"Remove"},"delete_alert":"Are you sure you want to remove product {name}?"},"pt-BR":{"buttons":{"edit":"Editar","remove":"Remover"},"delete_alert":"Tem certeza que deseja remover o produto {name}?"}}')
  delete Component.options._Ctor
}
